<script>
import { VALID_PALETTES } from './constants.js';
import { PALETTES } from 'design-assets/constants/palettes.js';
import vfBadge from './base-badge.vue';
import VueTypes from 'commons/util/vue-types.js';

export default {
    functional: true,

    props: {
        palette: VueTypes.oneOf(VALID_PALETTES).def(PALETTES.ACCENT),
        outline: VueTypes.bool.def(false),
        disabled: VueTypes.bool.def(false),
        ariaLabel: VueTypes.string,
    },

    render(h, { data, props, slots }) {
        return h(
            vfBadge,
            {
                class: [
                    'vf-pill-badge',
                    data.staticClass,
                    ...(data.class || []),
                ],
                props,
                attrs: {
                    ...(data.attrs || []),
                },
            },
            [ slots().default ],
        );
    },
};
</script>

<style lang="scss" scoped>
@import '../../../css/variables/module';

.vf-pill-badge {
    @include rem(border-radius, 1);
    @include rem(padding, 0.2 1);
}
</style>
